// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
const Users = ApiFactory.get('users');

const fetchAll = async ({ commit }, querystring) => {
  const { data } = await Users.getAll(querystring);
  commit('SET_DATA', data);
};

export default {
  fetchAll
};
